module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "nav"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.swiperData), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "nav-item"
    }, [_c('div', {
      staticClass: "nav-item-bg",
      on: {
        "click": function($event) {
          return _vm.clickPage(index)
        }
      }
    }, [_c('i'), _vm._v(" "), _c('p', [_vm._v(_vm._s(item))])])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-031679ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/center/centerBottom/index.vue
// module id = 1917
// module chunks = 2